import { mainBackendApi } from '@/services'
import { User } from '@/models/User'

export const UserService = mainBackendApi.injectEndpoints({
	endpoints: build => ({
		me: build.query<User, void>({
			query: () => ({
				url: '/auth/me',
				method: 'GET'
			}),
			providesTags: ['User']
		})
	})
})
